import { useCallback, useState } from "react";
import { createReview } from "../../api/reviews/PlaintrReview";
import { Form, json, useNavigate } from "react-router-dom";
import { Handler401 } from "../../api/utils/responseActions";

function ReviewForm(props) {
  const [rate, setRate] = useState(0);
  const [description, setDescription] = useState("");

  const navigate = useNavigate();

  async function submitReview() {
    let apiUrl = "review/plaintr-reviews";

    try {
      let queryData = {};

      queryData.star_number = rate;
      queryData.review_description = description;

      const response = await createReview(apiUrl, queryData);

      if (response.status === 401) {
        /**
         * TODO: Handle Unauthorized review requests due to
         *       not used the services.
         */
        Handler401(navigate);
        return;
      } else if (response.ok) {
        setRate(0);
        setDescription("");
      } else {
        throw json({ message: response.message }, { status: response.status });
      }
    } catch {}
  }

  const checkRateChanged = (event) => {
    setRate(event.target.value);
  };

  const checkDescriptionChanged = (event) => {
    setDescription(event.target.value);
  };

  const submitReviewHandler = useCallback((event) => {
    event.preventDefault();
    submitReview();
    event.target.reset();
    props.handleSubmitState(true);
  });

  return (
    <Form method="post" onSubmit={submitReviewHandler} style={{ flex: "60%" }}>
      <div className="accountant">
        <div>
          <div>
            <h3>Add a Review</h3>
            <div className="rating">
              <input
                type="radio"
                id="star5"
                name="rate"
                value="5"
                onChange={checkRateChanged}
              />
              <label className="mFont" htmlFor="star5" title="text">
                star
              </label>
              <input
                type="radio"
                id="star4"
                name="rate"
                value="4"
                onChange={checkRateChanged}
              />
              <label className="mFont" htmlFor="star4" title="text">
                star
              </label>
              <input
                type="radio"
                id="star3"
                name="rate"
                value="3"
                onChange={checkRateChanged}
              />
              <label className="mFont" htmlFor="star3" title="text">
                star
              </label>
              <input
                type="radio"
                id="star2"
                name="rate"
                value="2"
                onChange={checkRateChanged}
              />
              <label className="mFont" htmlFor="star2" title="text">
                star
              </label>
              <input
                type="radio"
                id="star1"
                name="rate"
                value="1"
                onChange={checkRateChanged}
              />
              <label className="mFont" htmlFor="star1" title="text">
                star
              </label>
            </div>
          </div>
          <div className="inputText">
            <textarea
              rows="5"
              required
              onChange={checkDescriptionChanged}
            ></textarea>
            <label>Write Review</label>
          </div>
          <button className="btn btnBox">
            <b>Submit</b>
          </button>
        </div>
      </div>
    </Form>
  );
}

export default ReviewForm;
